import React from "react";
import { Button } from "@shadcn-in-nx/ui/button";
import { Input } from "@shadcn-in-nx/ui/input";
import { Label } from "@shadcn-in-nx/ui/label";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@shadcn-in-nx/ui/select";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    DialogFooter,
} from "@shadcn-in-nx/ui/dialog";
import { Settings } from "lucide-react";

function TableColumnDialog({ open, onOpenChange, onAddColumn }) {
    const [name, setName] = React.useState("");
    const [type, setType] = React.useState("string");

    const handleOpenChange = (isOpen) => {
        onOpenChange(isOpen);
        if (isOpen) {
            setName("");
            setType("string");
        }
    };

    const handleAdd = () => {
        onAddColumn(name, type);
    };

    return (
        <Dialog open={open} onOpenChange={handleOpenChange}>
            <DialogTrigger asChild>
                <Button variant="outline" size="sm" className="flex-shrink-0">
                    <Settings className="w-4 h-4 md:mr-2" />
                    <span className="hidden md:inline">Columns</span>
                </Button>
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Add New Column</DialogTitle>
                </DialogHeader>
                <div className="space-y-4">
                    <div>
                        <Label htmlFor="columnName">Column Name</Label>
                        <Input
                            id="columnName"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter column name"
                        />
                    </div>
                    <div>
                        <Label htmlFor="columnType">Column Type</Label>
                        <Select value={type || "string"} onValueChange={setType}>
                            <SelectTrigger>
                                <SelectValue placeholder="Select column type (defaults to Text)" />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="string">Text</SelectItem>
                                <SelectItem value="number">Number</SelectItem>
                                <SelectItem value="boolean">Boolean</SelectItem>
                                <SelectItem value="date">Date</SelectItem>
                                <SelectItem value="json">JSON</SelectItem>
                            </SelectContent>
                        </Select>
                    </div>
                </div>
                <DialogFooter>
                    <Button onClick={handleAdd}>Add Column</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default React.memo(TableColumnDialog);
